import React from 'react';
import styles from './OfferPage.module.css';

interface OfferAppliedBarProps {
	appliedAt?: string | null;
}

function formatAppliedDate(appliedAt?: string | null): string | null {
	if (!appliedAt) return null;

	const parsed = new Date(appliedAt);
	if (Number.isNaN(parsed.getTime())) return null;

	return new Intl.DateTimeFormat('ru-RU', {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	})
		.format(parsed)
		.replace(/\s*г\.?\s*$/u, '');
}

function AppliedCheckIcon(): React.ReactElement {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
			<path
				d="M4 10.5L8 14.5L16 5.5"
				stroke="currentColor"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export function OfferAppliedBar({appliedAt}: OfferAppliedBarProps): React.ReactElement {
	const appliedDate = formatAppliedDate(appliedAt);
	const label = appliedDate ? `Вы откликнулись ${appliedDate}` : 'Вы откликнулись';

	return (
		<div className={styles.appliedBar}>
			<span>{label}</span>
			<AppliedCheckIcon />
		</div>
	);
}
